/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

export const getApiKeyDeviceRequestSchema = z
	.object({
		code: z.string().min(1),
	})
	.describe("Сериализатор получения и проверки кода устройства.");
